import React, { useState, useEffect } from "react";
import { Cpu, ShieldCheck, Zap, Download } from "lucide-react";

export const Header: React.FC = () => {
  const [deferredPrompt, setDeferredPrompt] = useState<any>(null);

  useEffect(() => {
    const handleBeforeInstallPrompt = (e: Event) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    return () => window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
  }, []);

  const handleInstallPWA = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === "accepted") {
      setDeferredPrompt(null);
    }
  };

  return (
    <header className="header-bar">
      <div className="brand-logo">
        <div className="logo-badge">
          <Cpu size={26} />
        </div>
        <div>
          <h1 className="brand-title gradient-title">CYBER // SEO MATRIX</h1>
          <div className="brand-subtitle">
            <span className="status-dot"></span>
            <span>CORE ENGINE ONLINE v2.5</span>
            <span style={{ margin: "0 0.4rem", opacity: 0.3 }}>|</span>
            <Zap size={12} color="#00f3ff" />
            <span>CLOUDFLARE PAGES READY</span>
          </div>
        </div>
      </div>

      <div style={{ display: "flex", gap: "0.75rem", alignItems: "center", flexWrap: "wrap" }}>
        {deferredPrompt && (
          <button
            onClick={handleInstallPWA}
            style={{
              background: "linear-gradient(135deg, rgba(0, 255, 157, 0.2), rgba(0, 243, 255, 0.2))",
              border: "1px solid var(--neon-emerald)",
              padding: "0.4rem 0.85rem",
              borderRadius: "20px",
              fontSize: "0.75rem",
              fontFamily: "var(--font-mono)",
              color: "var(--neon-emerald)",
              display: "flex",
              alignItems: "center",
              gap: "0.4rem",
              cursor: "pointer",
              boxShadow: "0 0 12px rgba(0, 255, 157, 0.3)",
            }}
          >
            <Download size={14} />
            <span>INSTALL PWA APP</span>
          </button>
        )}

        <div
          style={{
            background: "rgba(0, 243, 255, 0.05)",
            border: "1px solid rgba(0, 243, 255, 0.2)",
            padding: "0.4rem 0.85rem",
            borderRadius: "20px",
            fontSize: "0.75rem",
            fontFamily: "var(--font-mono)",
            color: "var(--neon-cyan)",
            display: "flex",
            alignItems: "center",
            gap: "0.4rem",
          }}
        >
          <ShieldCheck size={14} />
          <span>EDGE INTEL ACTIVE</span>
        </div>
      </div>
    </header>
  );
};
